import { ValueView } from "web/components"
import { getSummaryMethodLabel } from "../SummaryTiles/util"

import { RecordContext } from "web/contexts"
import { isNotAValue, isObjectWithProperty } from "web/services/helpers"
import classNames from "classnames"

function TileFieldView({
  field,
  summaryMethod,
  hasFieldAction,
  fieldAction,
  displayValue,
  divide = false,
}) {
  const readOnly = displayValue.value.kind === "RichText"

  return (
    <>
      <div
        className={classNames(
          "flex h-[30px] items-center truncate pr-1.5 text-sm text-gray-500",
          { "border-t border-gray-50": divide }
        )}
      >
        <p className="truncate">{field.label}</p>
      </div>
      <div
        className={classNames(
          "flex h-[30px] min-w-4xs items-center justify-end truncate text-sm",
          {
            "cursor-pointer text-primary-4 hover:text-feature-6":
              hasFieldAction,
            "border-t border-gray-50": divide,
          }
        )}
        onClick={fieldAction}
      >
        <ValueView
          fieldKey={field.key}
          fieldPresentation={field.presentation}
          {...displayValue}
          percentValue={field.percent_value}
          readOnly={readOnly}
        />
        {summaryMethod && (
          <span className="ml-1 text-xs text-gray-400">
            ({getSummaryMethodLabel(summaryMethod)})
          </span>
        )}
      </div>
    </>
  )
}

export default function TileRecordView({
  data,
  fields,
  fieldActions = {},
  isDoubleColumn,
  displayEmptyValues = false,
}) {
  if (data === undefined) return null

  const hasSummarizedRecords =
    data.summarizable_count && data.summarizable_count > 1

  const renderFields = (start, end) =>
    fields
      .filter(
        (field) => displayEmptyValues || !isNotAValue(data.values[field.key])
      )
      .slice(start, end)
      .map((field, i) => {
        const hasFieldAction = field.name in fieldActions

        const fieldAction = hasFieldAction
          ? () => fieldActions[field.name](data)
          : () => {}

        const displayValue = isObjectWithProperty(
          data.values[field.key],
          "value"
        )
          ? data.values[field.key]
          : {
              value: isNotAValue(data.values[field.key])
                ? { value: "", kind: "Text" }
                : data.values[field.key],
            }

        return (
          <TileFieldView
            key={field.key}
            field={field}
            summaryMethod={hasSummarizedRecords ? field.summary_method : null}
            hasFieldAction={hasFieldAction}
            fieldAction={fieldAction}
            displayValue={displayValue}
            divide={i > 0}
          />
        )
      })

  return (
    <RecordContext.Provider value={data}>
      <div
        className={classNames("grid gap-14", {
          "grid-cols-1": !isDoubleColumn,
          "grid-cols-2": isDoubleColumn,
        })}
      >
        <div>
          <div
            className="grid w-full min-w-[45%] text-left"
            style={{
              gridTemplateColumns: "fit-content(80%) 1fr",
            }}
          >
            {renderFields(0, 10)}
          </div>
        </div>
        <div>
          <div
            className="grid w-full min-w-[45%] text-left"
            style={{
              gridTemplateColumns: "fit-content(80%) 1fr",
            }}
          >
            {renderFields(10, 20)}
          </div>
        </div>
      </div>
    </RecordContext.Provider>
  )
}
